import api from '../../api'
import { useEffect, useState } from 'react'
import styles from './style.module.css'
import { PageContent, Breadcrumbs } from '../../components';

const FlatPages = () => {
    const curPath = window.location.pathname
    const [flatpage, setFlatPage] = useState([])
    useEffect(() => {
        api.getFlatPage()
            .then((data) => {
                setFlatPage(data);
            })
            .catch((err) => {
                console.log(err.message);
            });
    }, []);
    return (
        flatpage.results?.map((page) => {
            if (page.url === curPath) {
                return (
                    <PageContent key={page.id ?? page.url} title={page.title}>
                        <Breadcrumbs urls={[{ title: page.title, path: '' }]} />
                        <div className={styles.flatpage__content} dangerouslySetInnerHTML={{__html: page.content}} />
                    </PageContent>
                );
            }
            return null;
          })          
    );
}

export default FlatPages;